import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import './AppColumnLabelValue.scss';

function AppColumnLabelValue({ label, value, labelClass, valueClass }) {
  return (
    <Row>
      <Col lg={12}>
        <span className={`label-header ${labelClass}`}>{label}</span>
      </Col>
      <Col lg={12}>
        <span className={`label-value ${valueClass}`}>{value}</span>
      </Col>
    </Row>
  );
}

AppColumnLabelValue.defaultProps = {
  labelClass: '',
  valueClass: '',
};

AppColumnLabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  labelClass: PropTypes.string,
  value: PropTypes.string.isRequired,
  valueClass: PropTypes.string,
};

export default AppColumnLabelValue;
